export default "__VITE_ASSET__CiLlwcjO__"